import { List, LayoutGrid, Table } from "lucide-react";
import { cn } from "@/cn";
import { DEFAULT_VIEW_MODES, type ViewMode } from "./view-mode";

interface ViewModeSwitcherProps {
  currentMode: ViewMode;
  onModeChange: (mode: ViewMode) => void;
  allowedModes?: ViewMode[];
  className?: string;
}

const MODE_META: Record<
  ViewMode,
  { Icon: typeof List; label: string }
> = {
  list: { Icon: List, label: "List" },
  cards: { Icon: LayoutGrid, label: "Cards" },
  table: { Icon: Table, label: "Table" },
};

export function ViewModeSwitcher({
  currentMode,
  onModeChange,
  allowedModes = DEFAULT_VIEW_MODES,
  className = "",
}: ViewModeSwitcherProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-0.5 rounded-md border border-border bg-card p-0.5",
        className,
      )}
    >
      {allowedModes.map((mode) => {
        const { Icon, label } = MODE_META[mode];
        const active = currentMode === mode;
        return (
          <button
            key={mode}
            type="button"
            onClick={() => onModeChange(mode)}
            className={cn(
              "inline-flex items-center gap-1.5 rounded px-2.5 py-1.5 text-xs font-medium transition",
              active
                ? "bg-brand text-brand-foreground"
                : "text-muted-foreground hover:text-foreground",
            )}
            title={label}
            aria-label={`Switch to ${label} view`}
          >
            <Icon className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">{label}</span>
          </button>
        );
      })}
    </div>
  );
}
